"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateBonusStatuses = void 0;
var profile_api_1 = require("@l2p/profile-api");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useGenerateBonusStatuses = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var statuses = new Set(__spreadArray(__spreadArray([], Object.values(profile_api_1.BonusCardStatus), true), Object.values(profile_api_1.FreeRoundStatus), true));
        return Array.from(statuses)
            .filter(function (status) {
            return status !== profile_api_1.BonusCardStatus.InProgress &&
                status !== profile_api_1.FreeRoundStatus.Active &&
                status !== profile_api_1.BonusCardStatus.Pending;
        })
            .map(function (key) { return ({
            label: t(key).toUpperCase(),
            value: key,
        }); });
    }, [t]);
};
exports.useGenerateBonusStatuses = useGenerateBonusStatuses;
